import { DEV_RC_DEFAULTS, FEATURE_FLAG_KEYS } from './constants';
import { remoteConfigStore } from './remote-config.store';
/** Simple in-process DEV provider — used only when import.meta.env.DEV is true. */
class DevRemoteConfigProvider {
    constructor() {
        this._data = new Map(Object.entries(DEV_RC_DEFAULTS));
    }
    getValue(key, fallback) {
        const v = this._data.get(key);
        return v !== undefined ? v : fallback;
    }
    getAll() {
        return Object.fromEntries(this._data);
    }
    async fetch() {
        // already loaded
    }
}
export class RemoteConfigService {
    constructor(provider) {
        if (provider) {
            this._provider = provider;
        }
        else if (import.meta.env.DEV) {
            this._provider = new DevRemoteConfigProvider();
        }
        else {
            throw new Error('RemoteConfigService: a provider must be supplied in non-DEV environments');
        }
    }
    async fetch() {
        await this._provider.fetch();
        const all = this._provider.getAll();
        const flags = {};
        const configs = {};
        for (const [key, value] of Object.entries(all)) {
            const isFlag = Object.values(FEATURE_FLAG_KEYS).includes(key);
            if (isFlag) {
                flags[key] = Boolean(value);
            }
            else {
                configs[key] = value;
            }
        }
        remoteConfigStore.setState({ flags, configs });
    }
    get(key, defaultValue) {
        return this._provider.getValue(key, defaultValue);
    }
    getBoolean(key, fallback = false) {
        return this._provider.getValue(key, fallback);
    }
    getNumber(key, fallback = 0) {
        return this._provider.getValue(key, fallback);
    }
    getString(key, fallback = '') {
        return this._provider.getValue(key, fallback);
    }
}
